export default "/images/icon_key_luxe.svg?11cde0e007077af22eda2fa511860bae";